import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenKey = 'access_token';
  private rolesKey = 'roles';

  constructor(private http: HttpClient) {}

  setToken(token: string) {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  setRoles(roles: string[]) {
    localStorage.setItem(this.rolesKey, JSON.stringify(roles));
  }

  getRoles(): string[] {
    const roles = localStorage.getItem(this.rolesKey);
    return roles ? JSON.parse(roles) : [];
  }

  hasRolesCached(): boolean {
    return localStorage.getItem(this.rolesKey) !== null;
  }

  isInRole(role: string): boolean {
    return this.getRoles().includes(role);
  }

  clear() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.rolesKey);
  }
}
